<p-message
    [severity]="this.props?.severity ?? severity()"
    [variant]="this.props?.variant ?? variant()"
    [closable]="this.props?.closable ?? closable()"
    [life]="this.props?.life ?? life()"
    [icon]="this.props?.icon ?? icon()"
    [closeIcon]="this.props?.closeIcon ?? closeIcon()"
    [size]="this.props?.size ?? size()"
>
    @if ((this.props?.message ?? message())?.length > 0) {
        <span>{{
            this.props?.translate || translate()
                ? (this.props?.message ?? message() | translate)
                : this.props?.message ?? message()
        }}</span>
    } @else {
        <ng-content></ng-content>
    }
</p-message>
